import Swiper from "swiper";
import { FreeMode } from "swiper/modules";

import "swiper/css";
import "swiper/css/free-mode";

export default function swiperPropertyGalleryGrid() {
    if (!document.querySelector(".property-gallery-grid-swiper")) return;

    const swiper = new Swiper(".property-gallery-grid-swiper", {
        modules: [FreeMode],
        slidesPerView: 1.2,
        spaceBetween: 16,
        freeMode: true,
        grabCursor: true,
        speed: 1000,
        
        breakpoints: {
            768: {
                slidesPerView: 1.5,
            },
            
        }
    });
}
